import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import makeRequest from "../../../../api";
import { trainerService } from "../../../../api/services";
import { toast } from "react-toastify";

const AddPermission = () => {
  const navigate = useNavigate();

  const [inputData, setInputData] = useState({
    permissionDisplayName: "",
    permissionValue: "",
  });

  const addPermission = async () => {
    try {
      const res = await makeRequest(
        trainerService.addTrainerPermissions(inputData)
      );
      toast.success("Permission added successfully!");
      navigate("/admin/permissions");
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    }
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    addPermission();
  };

  return (
    <div className="container-lg">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/admin/permissions">Permissions</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Add
            </li>
          </ol>
        </nav>
      </div>
      <div className="w-50">
        <form onSubmit={handleSubmit}>
          <div className="form-goup mb-4">
            <label className="mb-2" htmlFor="name">
              <strong>Permission name</strong>
            </label>
            <input
              type="text"
              name="permissionDisplayName"
              id="name"
              className="form-control"
              placeholder="Enter permission name"
              value={inputData.permissionDisplayName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-goup mb-4">
            <label className="mb-2" htmlFor="value">
              <strong>Permission value</strong>
            </label>
            <input
              type="text"
              name="permissionValue"
              id="value"
              className="form-control"
              placeholder="Enter permission value"
              value={inputData.permissionValue}
              onChange={handleChange}
              required
            />
          </div>
          <button className="btn btn-sm btn-outline-success">
            Add permission
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddPermission;
